import { render } from "./FtrInput.vue?vue&type=template&id=5395f378&scoped=true"
import script from "./FtrInput.vue?vue&type=script&lang=js"
export * from "./FtrInput.vue?vue&type=script&lang=js"

import "./FtrInput.vue?vue&type=style&index=0&id=5395f378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5395f378"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
